module.exports = __webpack_public_path__ + "static/media/filter_off.b28619ef.png";